// Client für das SmartHaus-Backend (Roborock S7 "Schnuffel").
// Läuft auf 10.10.0.5:8000, wird via nginx unter reckhaus.it/api/ proxied.
// nginx beschränkt /api/ per allow/deny aufs Heimnetz — von außen kommt 403.
// Siehe FastAPI-Docs unter /docs auf dem Backend.

const BASE_URL = '/api'

export async function req(path, { method = 'GET', body, timeout = 8000, raw = false } = {}) {
  const ctrl = new AbortController()
  const tid = setTimeout(() => ctrl.abort(), timeout)
  try {
    const res = await fetch(BASE_URL + path, {
      method,
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal: ctrl.signal,
    })
    if (!res.ok) {
      const text = await res.text().catch(() => '')
      throw new Error(`HTTP ${res.status} ${path}: ${text}`)
    }
    if (raw) return await res.arrayBuffer()
    return await res.json()
  } finally {
    clearTimeout(tid)
  }
}

export const vacuumApi = {
  baseUrl: BASE_URL,
  ping: () => req('/vacuum/status', { timeout: 3000 }),
  status: () => req('/vacuum/status'),
  mapRaw: () => req('/vacuum/map.raw', { raw: true, timeout: 12000 }),
  rooms: () => req('/vacuum/rooms'),
  start: () => req('/vacuum/start', { method: 'POST' }),
  pause: () => req('/vacuum/pause', { method: 'POST' }),
  stop: () => req('/vacuum/stop', { method: 'POST' }),
  dock: () => req('/vacuum/dock', { method: 'POST' }),
  find: () => req('/vacuum/find', { method: 'POST' }),
  setFan: (level) => req('/vacuum/fan', { method: 'POST', body: { level } }),
  setWater: (level) => req('/vacuum/water', { method: 'POST', body: { level } }),
  setMop: (mode) => req('/vacuum/mop', { method: 'POST', body: { mode } }),
  cleanRooms: (payload) => req('/vacuum/clean-rooms', { method: 'POST', body: payload }),
  cleanZones: (zones) => req('/vacuum/clean-zones', { method: 'POST', body: { zones } }),
  cleanRecords: (limit = 20) => req(`/vacuum/clean-records?limit=${limit}`),
  goto: (x, y) => req('/vacuum/goto', { method: 'POST', body: { x: Math.round(x), y: Math.round(y) } }),
  wash: () => req('/vacuum/wash', { method: 'POST' }),
  washStop: () => req('/vacuum/wash-stop', { method: 'POST' }),
  rcStart: () => req('/vacuum/rc/start', { method: 'POST' }),
  rcMove: (omega, velocity, duration_ms = 1000) =>
    req('/vacuum/rc/move', { method: 'POST', body: { omega, velocity, duration_ms } }),
  rcStop: () => req('/vacuum/rc/stop', { method: 'POST' }),
  rcEnd: () => req('/vacuum/rc/end', { method: 'POST' }),
}

// RC-Joystick-Grenzwerte aus der API.
export const RC_MAX_VELOCITY = 0.3
export const RC_MAX_OMEGA = 3.1

// Lookup-Tabellen passend zur Backend-API (siehe /docs).
export const STATE_LABELS = {
  1: 'Initialisierung',
  2: 'An der Ladestation',
  3: 'Bereit',
  4: 'Fernsteuerung',
  5: 'Reinigt',
  6: 'Fährt zur Ladestation',
  7: 'Manuelle Fahrt',
  8: 'Lädt',
  9: 'Ladefehler',
  10: 'Pause',
  11: 'Reinigt Punkt',
  12: 'Fehler',
  13: 'Heruntergefahren',
  14: 'Update läuft',
  15: 'Sucht Dock',
  16: 'Fährt zu Zielort',
  17: 'Reinigt Zone',
  18: 'Reinigt Raum',
  22: 'Leert Staubbehälter am Dock',
  23: 'Wäscht Mopp',
  26: 'Kehrt zum Wäscher zurück',
  100: 'Komplett aufgeladen',
}

export const FAN_LEVELS = [
  { value: 101, label: 'Leise', icon: 'mdi-volume-low', hint: 'Nachts, leise Räume' },
  { value: 102, label: 'Normal', icon: 'mdi-volume-medium', hint: 'Alltag, stromsparend' },
  { value: 103, label: 'Turbo', icon: 'mdi-volume-high', hint: 'Sichtbarer Schmutz' },
  { value: 104, label: 'Max', icon: 'mdi-rocket-launch', hint: 'Teppich, gröbster Dreck' },
]

export const WATER_MODES = [
  { value: 200, label: 'Aus', icon: 'mdi-water-off', hint: 'Kein Wischen' },
  { value: 201, label: 'Wenig', icon: 'mdi-water-minus', hint: 'Holz, empfindlich' },
  { value: 202, label: 'Mittel', icon: 'mdi-water', hint: 'Fliesen, Laminat' },
  { value: 203, label: 'Stark', icon: 'mdi-water-plus', hint: 'Stein, viel Schmutz' },
]

export const MOP_MODES = [
  { value: 300, label: 'Standard', hint: 'Schneller fertig' },
  { value: 301, label: 'Gründlich', hint: 'Engere Bahnen' },
  { value: 303, label: 'Sehr gründlich', hint: 'Max. Bahnen, langsamer' },
]
